export const VISITOR = 'VISITOR';
export const RESPONDER = 'RESPONDER';